// Multi-CSV data loader for findhorn project

// Raw CSV data for different scenarios
const CSV_RAW_DATA = {
    DATA: `Day,Hour,Mins,Time,generation_kW,demand_kW,Surplus (kW),PV used,Residual demand (kW)
1.00,0,0,0.00,0,0.0318,0,0,0.0318
1.00,0,15,0.25,0,0.0318,0,0,0.0318
1.00,0,30,0.50,0,0.1338,0,0,0.1338
1.00,0,45,0.75,0,0.033,0,0,0.033
1.00,1,0,1.00,0,0.1362,0,0,0.1362
1.00,1,15,1.25,0,0.033,0,0,0.033
1.00,1,30,1.50,0,0.033,0,0,0.033
1.00,1,45,1.75,0,0.1698,0,0,0.1698
1.00,2,0,2.00,0,0.1692,0,0,0.1692
1.00,2,15,2.25,0,0.0312,0,0,0.0312
1.00,2,30,2.50,0,0.1422,0,0,0.1422
1.00,2,45,2.75,0,0.135,0,0,0.135
1.00,3,0,3.00,0,0.0318,0,0,0.0318
1.00,3,15,3.25,0,0.0528,0,0,0.0528
1.00,3,30,3.50,0,0.0312,0,0,0.0312
1.00,3,45,3.75,0,0.0312,0,0,0.0312
1.00,4,0,4.00,0,0.1368,0,0,0.1368
1.00,4,15,4.25,0,0.0312,0,0,0.0312
1.00,4,30,4.50,0,0.03,0,0,0.03
1.00,4,45,4.75,0,0.132,0,0,0.132
1.00,5,0,5.00,0,0.0312,0,0,0.0312
1.00,5,15,5.25,0,0.045,0,0,0.045
1.00,5,30,5.50,0,0.033,0,0,0.033
1.00,5,45,5.75,0,0.033,0,0,0.033
1.00,6,0,6.00,0.0162,0.1368,0,0.0162,0.1206
1.00,6,15,6.25,0.0312,0.0318,0,0.0312,0.0006
1.00,6,30,6.50,0.0582,0.0378,0.0204,0.0378,0
1.00,6,45,6.75,0.0612,0.1302,0,0.0612,0.069
1.00,7,0,7.00,0.063,0.0258,0.0372,0.0258,0
1.00,7,15,7.25,0.102,0.027,0.075,0.027,0
1.00,7,30,7.50,0.102,0.033,0.069,0.033,0
1.00,7,45,7.75,0.1698,0.135,0.0348,0.135,0
1.00,8,0,8.00,0.204,0.3228,0,0.204,0.1188
1.00,8,15,8.25,0.2388,0.105,0.1338,0.105,0
1.00,8,30,8.50,0.2388,0.0462,0.1926,0.0462,0
1.00,8,45,8.75,0.2622,0.1362,0.126,0.1362,0
1.00,9,0,9.00,0.3198,0.06,0.2598,0.06,0
1.00,9,15,9.25,0.2172,0.06,0.1572,0.06,0
1.00,9,30,9.50,0.402,0.0522,0.3498,0.0522,0
1.00,9,45,9.75,0.4452,0.0588,0.3864,0.0588,0
1.00,10,0,10.00,0.6,0.1518,0.4482,0.1518,0
1.00,10,15,10.25,0.4368,0.0462,0.3906,0.0462,0
1.00,10,30,10.50,0.4062,0.0618,0.3444,0.0618,0
1.00,10,45,10.75,0.4842,2.0382,0,0.4842,1.554
1.00,11,0,11.00,0.6558,0.1218,0.534,0.1218,0
1.00,11,15,11.25,0.621,0.135,0.486,0.135,0
1.00,11,30,11.50,0.4638,1.962,0,0.4638,1.4982
1.00,11,45,11.75,0.828,0.0492,0.7788,0.0492,0
1.00,12,0,12.00,0.7908,0.156,0.6348,0.156,0
1.00,12,15,12.25,1.1028,0.0432,1.0596,0.0431999999999999,0
1.00,12,30,12.50,1.3512,0.0618,1.2894,0.0618000000000001,0
1.00,12,45,12.75,0.963,0.0462,0.9168,0.0462,0
1.00,13,0,13.00,0.609,0.0498,0.5592,0.0498,0
1.00,13,15,13.25,0.828,0.147,0.681,0.147,0
1.00,13,30,13.50,0.879,0.0498,0.8292,0.0498,0
1.00,13,45,13.75,1.1148,0.0498,1.065,0.0498000000000001,0
1.00,14,0,14.00,0.984,0.2502,0.7338,0.2502,0
1.00,14,15,14.25,0.9252,0.1572,0.768,0.1572,0
1.00,14,30,14.50,1.5798,0.2088,1.371,0.2088,0
1.00,14,45,14.75,0.837,0.237,0.6,0.237,0
1.00,15,0,15.00,0.831,0.1542,0.6768,0.1542,0
1.00,15,15,15.25,1.623,0.243,1.38,0.243,0
1.00,15,30,15.50,0.753,0.3228,0.4302,0.3228,0
1.00,15,45,15.75,1.2552,2.1672,0,1.2552,0.912
1.00,16,0,16.00,0.687,0.0588,0.6282,0.0588,0
1.00,16,15,16.25,1.2102,0.207,1.0032,0.207,0
1.00,16,30,16.50,0.744,1.3782,0,0.744,0.6342
1.00,16,45,16.75,0.6378,0.03,0.6078,0.03,0
1.00,17,0,17.00,0.4218,0.0402,0.3816,0.0402,0
1.00,17,15,17.25,0.489,0.135,0.354,0.135,0
1.00,17,30,17.50,0.4848,0.033,0.4518,0.033,0
1.00,17,45,17.75,0.564,0.0312,0.5328,0.0312,0
1.00,18,0,18.00,0.237,0.1458,0.0912,0.1458,0
1.00,18,15,18.25,0.1932,0.135,0.0582,0.135,0
1.00,18,30,18.50,0.1428,0.0408,0.102,0.0408,0
1.00,18,45,18.75,0.15,0.1422,0.00779999999999997,0.1422,0
1.00,19,0,19.00,0.225,0.1482,0.0768,0.1482,0
1.00,19,15,19.25,0.18,0.0312,0.1488,0.0312,0
1.00,19,30,19.50,0.1842,0.8322,0,0.1842,0.648
1.00,19,45,19.75,0.1842,0.0852,0.099,0.0852,0
1.00,20,0,20.00,0.1182,0.0342,0.084,0.0342,0
1.00,20,15,20.25,0.087,0.1572,0,0.087,0.0702
1.00,20,30,20.50,0.0462,0.1458,0,0.0462,0.0996
1.00,20,45,20.75,0.0288,0.1998,0,0.0288,0.171
1.00,21,0,21.00,0,0.291,0,0,0.291
1.00,21,15,21.25,0,0.1872,0,0,0.1872
1.00,21,30,21.50,0,0.1908,0,0,0.1908
1.00,21,45,21.75,0,0.2898,0,0,0.2898
1.00,22,0,22.00,0,0.189,0,0,0.189
1.00,22,15,22.25,0,0.0342,0,0,0.0342
1.00,22,30,22.50,0,0.0822,0,0,0.0822
1.00,22,45,22.75,0,0.0342,0,0,0.0342
1.00,23,0,23.00,0,0.1392,0,0,0.1392
1.00,23,15,23.25,0,0.0342,0,0,0.0342
1.00,23,30,23.50,0,0.033,0,0,0.033
1.00,23,45,23.75,0,0.1362,0,0,0.1362
2.00,0,0,0.00,0,0.0342,0,0,0.0342
2.00,0,15,0.25,0,0.033,0,0,0.033
2.00,0,30,0.50,0,0.1338,0,0,0.1338
2.00,0,45,0.75,0,0.0312,0,0,0.0312
2.00,1,0,1.00,0,0.0318,0,0,0.0318
2.00,1,15,1.25,0,0.0492,0,0,0.0492
2.00,1,30,1.50,0,0.0318,0,0,0.0318
2.00,1,45,1.75,0,0.1338,0,0,0.1338
2.00,2,0,2.00,0,0.0312,0,0,0.0312
2.00,2,15,2.25,0,0.0312,0,0,0.0312
2.00,2,30,2.50,0,0.1308,0,0,0.1308
2.00,2,45,2.75,0,0.0312,0,0,0.0312
2.00,3,0,3.00,0,0.0522,0,0,0.0522
2.00,3,15,3.25,0,0.1272,0,0,0.1272
2.00,3,30,3.50,0,0.0318,0,0,0.0318
2.00,3,45,3.75,0,0.0468,0,0,0.0468
2.00,4,0,4.00,0,0.0312,0,0,0.0312
2.00,4,15,4.25,0,0.0318,0,0,0.0318
2.00,4,30,4.50,0,0.1308,0,0,0.1308
2.00,4,45,4.75,0,0.0318,0,0,0.0318
2.00,5,0,5.00,0,0.033,0,0,0.033
2.00,5,15,5.25,0,0.132,0,0,0.132
2.00,5,30,5.50,0,0.0342,0,0,0.0342
2.00,5,45,5.75,0.0132,0.0402,0,0.0132,0.027
2.00,6,0,6.00,0.0408,0.081,0,0.0408,0.0402
2.00,6,15,6.25,0.0612,0.0462,0.015,0.0462,0
2.00,6,30,6.50,0.075,0.0462,0.0288,0.0462,0
2.00,6,45,6.75,0.117,0.0348,0.0822,0.0348,0
2.00,7,0,7.00,0.111,0.033,0.078,0.033,0
2.00,7,15,7.25,0.315,0.1248,0.1902,0.1248,0
2.00,7,30,7.50,0.183,0.0372,0.1458,0.0372,0
2.00,7,45,7.75,0.159,0.1362,0.0228,0.1362,0
2.00,8,0,8.00,0.168,0.276,0,0.168,0.108
2.00,8,15,8.25,0.1848,0.051,0.1338,0.051,0
2.00,8,30,8.50,0.255,0.0822,0.1728,0.0822,0
2.00,8,45,8.75,0.4098,0.1092,0.3006,0.1092,0
2.00,9,0,9.00,0.612,0.054,0.558,0.0540000000000001,0
2.00,9,15,9.25,0.4248,0.129,0.2958,0.129,0
2.00,9,30,9.50,0.549,0.051,0.498,0.051,0
2.00,9,45,9.75,0.564,0.0528,0.5112,0.0528,0
2.00,10,0,10.00,0.7218,2.088,0,0.7218,1.3662
2.00,10,15,10.25,0.7068,0.6918,0.015,0.6918,0
2.00,10,30,10.50,1.2012,0.1092,1.092,0.1092,0
2.00,10,45,10.75,1.8558,3.8028,0,1.8558,1.947
2.00,11,0,11.00,0.7128,1.9518,0,0.7128,1.239
2.00,11,15,11.25,0.6072,0.1272,0.48,0.1272,0
2.00,11,30,11.50,0.8088,0.0318,0.777,0.0318000000000001,0
2.00,11,45,11.75,0.6102,0.1248,0.4854,0.1248,0
2.00,12,0,12.00,0.807,0.0378,0.7692,0.0377999999999999,0
2.00,12,15,12.25,0.726,0.03,0.696,0.03,0
2.00,12,30,12.50,0.7722,0.03,0.7422,0.03,0
2.00,12,45,12.75,0.9858,0.135,0.8508,0.135,0
2.00,13,0,13.00,0.693,0.033,0.66,0.033,0
2.00,13,15,13.25,0.7812,1.2072,0,0.7812,0.426
2.00,13,30,13.50,0.8112,0.0312,0.78,0.0312,0
2.00,13,45,13.75,0.8658,0.0378,0.828,0.0378000000000001,0
2.00,14,0,14.00,0.918,0.0402,0.8778,0.0402,0
2.00,14,15,14.25,0.924,0.1152,0.8088,0.1152,0
2.00,14,30,14.50,0.6432,0.0978,0.5454,0.0978,0
2.00,14,45,14.75,0.6702,0.0948,0.5754,0.0948,0
2.00,15,0,15.00,0.912,0.1908,0.7212,0.1908,0
2.00,15,15,15.25,0.699,0.0732,0.6258,0.0732,0
2.00,15,30,15.50,0.537,0.1848,0.3522,0.1848,0
2.00,15,45,15.75,0.4452,0.084,0.3612,0.084,0
2.00,16,0,16.00,0.5142,0.1938,0.3204,0.1938,0
2.00,16,15,16.25,0.4752,0.1122,0.363,0.1122,0
2.00,16,30,16.50,0.3792,0.1458,0.2334,0.1458,0
2.00,16,45,16.75,0.3552,0.0462,0.309,0.0462,0
2.00,17,0,17.00,0.3948,0.138,0.2568,0.138,0
2.00,17,15,17.25,0.4398,0.033,0.4068,0.033,0
2.00,17,30,17.50,0.3888,0.1338,0.255,0.1338,0
2.00,17,45,17.75,0.342,0.033,0.309,0.033,0
2.00,18,0,18.00,0.4038,0.042,0.3618,0.042,0
2.00,18,15,18.25,0.2052,0.0318,0.1734,0.0318,0
2.00,18,30,18.50,0.2982,1.854,0,0.2982,1.5558
2.00,18,45,18.75,0.195,0.1728,0.0222,0.1728,0
2.00,19,0,19.00,0.234,0.171,0.063,0.171,0
2.00,19,15,19.25,0.1602,0.5622,0,0.1602,0.402
2.00,19,30,19.50,0.12,0.174,0,0.12,0.054
2.00,19,45,19.75,0.1818,0.201,0,0.1818,0.0192
2.00,20,0,20.00,0.0708,0.0972,0,0.0708,0.0264
2.00,20,15,20.25,0.0462,0.3558,0,0.0462,0.3096
2.00,20,30,20.50,0.0888,0.1902,0,0.0888,0.1014
2.00,20,45,20.75,0.0432,0.177,0,0.0432,0.1338
2.00,21,0,21.00,0.0462,0.174,0,0.0462,0.1278
2.00,21,15,21.25,0.024,0.183,0,0.024,0.159
2.00,21,30,21.50,0.0042,0.2742,0,0.0042,0.27
2.00,21,45,21.75,0,0.18,0,0,0.18
2.00,22,0,22.00,0,0.033,0,0,0.033
2.00,22,15,22.25,0,0.033,0,0,0.033
2.00,22,30,22.50,0,0.0348,0,0,0.0348
2.00,22,45,22.75,0,0.1248,0,0,0.1248
2.00,23,0,23.00,0,0.0342,0,0,0.0342
2.00,23,15,23.25,0,0.1368,0,0,0.1368
2.00,23,30,23.50,0,0.033,0,0,0.033
2.00,23,45,23.75,0,0.0318,0,0,0.0318
3.00,0,0,0.00,0,0.0498,0,0,0.0498
3.00,0,15,0.25,0,0.0318,0,0,0.0318
3.00,0,30,0.50,0,0.1338,0,0,0.1338
3.00,0,45,0.75,0,0.0318,0,0,0.0318
3.00,1,0,1.00,0,0.0318,0,0,0.0318
3.00,1,15,1.25,0,0.1182,0,0,0.1182
3.00,1,30,1.50,0,0.0318,0,0,0.0318
3.00,1,45,1.75,0,0.0318,0,0,0.0318
3.00,2,0,2.00,0,0.0312,0,0,0.0312
3.00,2,15,2.25,0,0.0312,0,0,0.0312
3.00,2,30,2.50,0,0.1242,0,0,0.1242
3.00,2,45,2.75,0,0.03,0,0,0.03
3.00,3,0,3.00,0,0.0318,0,0,0.0318
3.00,3,15,3.25,0,0.123,0,0,0.123
3.00,3,30,3.50,0,0.0318,0,0,0.0318
3.00,3,45,3.75,0,0.0318,0,0,0.0318
3.00,4,0,4.00,0,0.0318,0,0,0.0318
3.00,4,15,4.25,0,0.0312,0,0,0.0312
3.00,4,30,4.50,0,0.0318,0,0,0.0318
3.00,4,45,4.75,0,0.0318,0,0,0.0318
3.00,5,0,5.00,0,0.0318,0,0,0.0318
3.00,5,15,5.25,0,0.1038,0,0,0.1038
3.00,5,30,5.50,0,0.033,0,0,0.033
3.00,5,45,5.75,0.024,0.0372,0,0.024,0.0132
3.00,6,0,6.00,0.0372,0.1422,0,0.0372,0.105
3.00,6,15,6.25,0.0468,0.0372,0.0096,0.0372,0
3.00,6,30,6.50,0.0552,0.0402,0.015,0.0402,0
3.00,6,45,6.75,0.075,0.033,0.042,0.033,0
3.00,7,0,7.00,0.366,0.0372,0.3288,0.0372,0
3.00,7,15,7.25,0.4878,0.0318,0.456,0.0318,0
3.00,7,30,7.50,0.6168,0.033,0.5838,0.033,0
3.00,7,45,7.75,0.7392,0.1392,0.6,0.1392,0
3.00,8,0,8.00,0.8592,0.0942,0.765,0.0942,0
3.00,8,15,8.25,1.002,0.114,0.888,0.114,0
3.00,8,30,8.50,1.1112,0.1008,1.0104,0.1008,0
3.00,8,45,8.75,1.2228,1.5918,0,1.2228,0.369
3.00,9,0,9.00,1.3182,1.9878,0,1.3182,0.6696
3.00,9,15,9.25,1.413,1.9782,0,1.413,0.5652
3.00,9,30,9.50,1.491,1.992,0,1.491,0.501
3.00,9,45,9.75,1.5702,0.1902,1.38,0.1902,0
3.00,10,0,10.00,1.6548,0.0918,1.563,0.0917999999999999,0
3.00,10,15,10.25,1.6638,0.1278,1.536,0.1278,0
3.00,10,30,10.50,1.8612,0.189,1.6722,0.189,0
3.00,10,45,10.75,1.8858,0.0888,1.797,0.0888,0
3.00,11,0,11.00,1.968,0.186,1.782,0.186,0
3.00,11,15,11.25,2.0208,0.078,1.9428,0.0780000000000001,0
3.00,11,30,11.50,1.9932,0.069,1.9242,0.069,0
3.00,11,45,11.75,2.1132,0.0852,2.028,0.0851999999999999,0
3.00,12,0,12.00,2.0838,0.0768,2.007,0.0768,0
3.00,12,15,12.25,2.2032,0.0948,2.1084,0.0948000000000002,0
3.00,12,30,12.50,0.6252,0.1392,0.486,0.1392,0
3.00,12,45,12.75,0.5298,0.042,0.4878,0.042,0
3.00,13,0,13.00,1.506,0.189,1.317,0.189,0
3.00,13,15,13.25,0.729,0.078,0.651,0.078,0
3.00,13,30,13.50,1.3638,0.1632,1.2006,0.1632,0
3.00,13,45,13.75,0.642,0.0288,0.6132,0.0288,0
3.00,14,0,14.00,1.8258,0.0678,1.758,0.0678000000000001,0
3.00,14,15,14.25,1.8198,0.039,1.7808,0.0389999999999999,0
3.00,14,30,14.50,1.4862,0.0498,1.4364,0.0498000000000001,0
3.00,14,45,14.75,2.0892,0.0582,2.031,0.0581999999999998,0
3.00,15,0,15.00,0.4662,0.0582,0.408,0.0582,0
3.00,15,15,15.25,1.6668,0.0618,1.605,0.0618000000000001,0
3.00,15,30,15.50,1.6728,0.069,1.6038,0.069,0
3.00,15,45,15.75,1.668,0.1518,1.5162,0.1518,0
3.00,16,0,16.00,1.6788,0.7362,0.9426,0.7362,0
3.00,16,15,16.25,1.3782,0.7722,0.606,0.7722,0
3.00,16,30,16.50,0.648,0.0642,0.5838,0.0642,0
3.00,16,45,16.75,0.5508,0.042,0.5088,0.042,0
3.00,17,0,17.00,0.7158,0.042,0.6738,0.042,0
3.00,17,15,17.25,0.453,0.0858,0.3672,0.0858,0
3.00,17,30,17.50,0.2928,0.084,0.2088,0.084,0
3.00,17,45,17.75,0.2532,0.0888,0.1644,0.0888,0
3.00,18,0,18.00,0.207,0.0738,0.1332,0.0738,0
3.00,18,15,18.25,0.1758,0.072,0.1038,0.072,0
3.00,18,30,18.50,0.1422,0.0408,0.1014,0.0408,0
3.00,18,45,18.75,0.1242,0.09,0.0342,0.09,0
3.00,19,0,19.00,0.108,0.036,0.072,0.036,0
3.00,19,15,19.25,0.09,0.1302,0,0.09,0.0402
3.00,19,30,19.50,0.0708,0.03,0.0408,0.03,0
3.00,19,45,19.75,0.0612,0.1278,0,0.0612,0.0666
3.00,20,0,20.00,0.048,0.024,0.024,0.024,0
3.00,20,15,20.25,0.0378,0.129,0,0.0378,0.0912
3.00,20,30,20.50,0.0252,0.0312,0,0.0252,0.006
3.00,20,45,20.75,0.0042,0.1758,0,0.0042,0.1716
3.00,21,0,21.00,0.0018,0.0288,0,0.0018,0.027
3.00,21,15,21.25,0,0.0318,0,0,0.0318
3.00,21,30,21.50,0,0.0342,0,0,0.0342
3.00,21,45,21.75,0,0.4122,0,0,0.4122
3.00,22,0,22.00,0,0.189,0,0,0.189
3.00,22,15,22.25,0,0.1812,0,0,0.1812
3.00,22,30,22.50,0,0.141,0,0,0.141
3.00,22,45,22.75,0,0.0342,0,0,0.0342
3.00,23,0,23.00,0,0.132,0,0,0.132
3.00,23,15,23.25,0,0.0342,0,0,0.0342
3.00,23,30,23.50,0,0.0342,0,0,0.0342
3.00,23,45,23.75,0,0.0342,0,0,0.0342
4.00,0,0,0.00,0,0.0348,0,0,0.0348
4.00,0,15,0.25,0,0.1242,0,0,0.1242
4.00,0,30,0.50,0,0.0318,0,0,0.0318
4.00,0,45,0.75,0,0.1338,0,0,0.1338
4.00,1,0,1.00,0,0.0318,0,0,0.0318
4.00,1,15,1.25,0,0.03,0,0,0.03
4.00,1,30,1.50,0,0.042,0,0,0.042
4.00,1,45,1.75,0,0.0318,0,0,0.0318
4.00,2,0,2.00,0,0.1308,0,0,0.1308
4.00,2,15,2.25,0,0.0312,0,0,0.0312
4.00,2,30,2.50,0,0.0342,0,0,0.0342
4.00,2,45,2.75,0,0.1068,0,0,0.1068
4.00,3,0,3.00,0,0.0318,0,0,0.0318
4.00,3,15,3.25,0,0.0318,0,0,0.0318
4.00,3,30,3.50,0,0.0318,0,0,0.0318
4.00,3,45,3.75,0,0.0312,0,0,0.0312
4.00,4,0,4.00,0,0.1242,0,0,0.1242
4.00,4,15,4.25,0,0.0318,0,0,0.0318
4.00,4,30,4.50,0,0.0312,0,0,0.0312
4.00,4,45,4.75,0,0.0402,0,0,0.0402
4.00,5,0,5.00,0,0.0318,0,0,0.0318
4.00,5,15,5.25,0,0.0318,0,0,0.0318
4.00,5,30,5.50,0,0.033,0,0,0.033
4.00,5,45,5.75,0.0222,0.0318,0,0.0222,0.0096
4.00,6,0,6.00,0.036,0.1362,0,0.036,0.1002
4.00,6,15,6.25,0.0468,0.0342,0.0126,0.0342,0
4.00,6,30,6.50,0.0588,0.0402,0.0186,0.0402,0
4.00,6,45,6.75,0.0768,0.1278,0,0.0768,0.051
4.00,7,0,7.00,0.3282,0.0318,0.2964,0.0318,0
4.00,7,15,7.25,0.4518,0.1398,0.312,0.1398,0
4.00,7,30,7.50,0.5808,0.1908,0.39,0.1908,0
4.00,7,45,7.75,0.711,0.1038,0.6072,0.1038,0
4.00,8,0,8.00,0.819,0.1968,0.6222,0.1968,0
4.00,8,15,8.25,0.9552,0.0708,0.8844,0.0708,0
4.00,8,30,8.50,1.068,0.066,1.002,0.0660000000000001,0
4.00,8,45,8.75,1.155,0.159,0.996,0.159,0
4.00,9,0,9.00,1.2552,0.0678,1.1874,0.0678000000000001,0
4.00,9,15,9.25,1.3542,0.0498,1.3044,0.0498000000000001,0
4.00,9,30,9.50,1.428,0.0498,1.3782,0.0498000000000001,0
4.00,9,45,9.75,1.515,0.039,1.476,0.0389999999999999,0
4.00,10,0,10.00,1.593,0.1428,1.4502,0.1428,0
4.00,10,15,10.25,1.4112,0.0642,1.347,0.0642,0
4.00,10,30,10.50,0.3948,0.0342,0.3606,0.0342,0
4.00,10,45,10.75,2.0718,2.2332,0,2.0718,0.1614
4.00,11,0,11.00,1.953,0.0402,1.9128,0.0402,0
4.00,11,15,11.25,0.5658,0.1188,0.447,0.1188,0
4.00,11,30,11.50,0.576,1.959,0,0.576,1.383
4.00,11,45,11.75,0.594,0.1902,0.4038,0.1902,0
4.00,12,0,12.00,2.2662,0.075,2.1912,0.0750000000000002,0
4.00,12,15,12.25,2.1048,1.956,0.1488,1.956,0
4.00,12,30,12.50,1.1112,0.1038,1.0074,0.1038,0
4.00,12,45,12.75,0.6888,0.171,0.5178,0.171,0
4.00,13,0,13.00,0.807,0.072,0.735,0.072,0
4.00,13,15,13.25,0.5772,0.177,0.4002,0.177,0
4.00,13,30,13.50,0.4968,1.4988,0,0.4968,1.002
4.00,13,45,13.75,0.633,0.09,0.543,0.09,0
4.00,14,0,14.00,0.5952,0.1098,0.4854,0.1098,0
4.00,14,15,14.25,0.96,0.057,0.903,0.0570000000000001,0
4.00,14,30,14.50,0.924,0.0558,0.8682,0.0558,0
4.00,14,45,14.75,0.681,0.057,0.624,0.0570000000000001,0
4.00,15,0,15.00,1.263,0.0648,1.1982,0.0648,0
4.00,15,15,15.25,0.8118,0.0558,0.756,0.0558,0
4.00,15,30,15.50,0.6522,0.0582,0.594,0.0582,0
4.00,15,45,15.75,0.5472,0.0768,0.4704,0.0768,0
4.00,16,0,16.00,0.5658,0.6318,0,0.5658,0.066
4.00,16,15,16.25,0.5022,1.077,0,0.5022,0.5748
4.00,16,30,16.50,0.4902,0.0552,0.435,0.0552,0
4.00,16,45,16.75,0.417,0.2082,0.2088,0.2082,0
4.00,17,0,17.00,0.3288,0.0312,0.2976,0.0312,0
4.00,17,15,17.25,0.5292,0.1158,0.4134,0.1158,0
4.00,17,30,17.50,0.3378,0.03,0.3078,0.03,0
4.00,17,45,17.75,0.384,0.0288,0.3552,0.0288,0
4.00,18,0,18.00,0.3102,0.0318,0.2784,0.0318,0
4.00,18,15,18.25,0.1842,0.0288,0.1554,0.0288,0
4.00,18,30,18.50,0.1602,0.0348,0.1254,0.0348,0
4.00,18,45,18.75,0.225,0.1032,0.1218,0.1032,0
4.00,19,0,19.00,0.273,0.1062,0.1668,0.1062,0
4.00,19,15,19.25,0.2232,0.1032,0.12,0.1032,0
4.00,19,30,19.50,0.0978,0.0978,0,0.0978,0
4.00,19,45,19.75,0.1182,0.042,0.0762,0.042,0
4.00,20,0,20.00,0.1098,0.033,0.0768,0.033,0
4.00,20,15,20.25,0.0552,0.1278,0,0.0552,0.0726
4.00,20,30,20.50,0.042,0.1062,0,0.042,0.0642
4.00,20,45,20.75,0.0342,0.198,0,0.0342,0.1638
4.00,21,0,21.00,0.0018,0.1008,0,0.0018,0.099
4.00,21,15,21.25,0,0.294,0,0,0.294
4.00,21,30,21.50,0,0.186,0,0,0.186
4.00,21,45,21.75,0,0.2328,0,0,0.2328
4.00,22,0,22.00,0,0.2262,0,0,0.2262
4.00,22,15,22.25,0,0.0348,0,0,0.0348
4.00,22,30,22.50,0,0.0342,0,0,0.0342
4.00,22,45,22.75,0,0.0342,0,0,0.0342
4.00,23,0,23.00,0,0.0342,0,0,0.0342
4.00,23,15,23.25,0,0.0342,0,0,0.0342
4.00,23,30,23.50,0,0.1272,0,0,0.1272
4.00,23,45,23.75,0,0.0342,0,0,0.0342
5.00,0,0,0.00,0,0.1332,0,0,0.1332
5.00,0,15,0.25,0,0.033,0,0,0.033
5.00,0,30,0.50,0,0.033,0,0,0.033
5.00,0,45,0.75,0,0.0312,0,0,0.0312
5.00,1,0,1.00,0,0.0318,0,0,0.0318
5.00,1,15,1.25,0,0.123,0,0,0.123
5.00,1,30,1.50,0,0.0312,0,0,0.0312
5.00,1,45,1.75,0,0.129,0,0,0.129
5.00,2,0,2.00,0,0.033,0,0,0.033
5.00,2,15,2.25,0,0.0318,0,0,0.0318
5.00,2,30,2.50,0,0.0312,0,0,0.0312
5.00,2,45,2.75,0,0.0312,0,0,0.0312
5.00,3,0,3.00,0,0.1212,0,0,0.1212
5.00,3,15,3.25,0,0.0318,0,0,0.0318
5.00,3,30,3.50,0,0.1392,0,0,0.1392
5.00,3,45,3.75,0,0.0312,0,0,0.0312
5.00,4,0,4.00,0,0.0312,0,0,0.0312
5.00,4,15,4.25,0,0.0312,0,0,0.0312
5.00,4,30,4.50,0,0.0312,0,0,0.0312
5.00,4,45,4.75,0,0.129,0,0,0.129
5.00,5,0,5.00,0,0.0318,0,0,0.0318
5.00,5,15,5.25,0,0.0318,0,0,0.0318
5.00,5,30,5.50,0,0.033,0,0,0.033
5.00,5,45,5.75,0.021,0.0312,0,0.021,0.0102
5.00,6,0,6.00,0.033,0.1278,0,0.033,0.0948
5.00,6,15,6.25,0.0492,0.036,0.0132,0.036,0
5.00,6,30,6.50,0.06,0.027,0.033,0.027,0
5.00,6,45,6.75,0.0768,0.0348,0.042,0.0348,0
5.00,7,0,7.00,0.3492,0.033,0.3162,0.033,0
5.00,7,15,7.25,0.4662,0.135,0.3312,0.135,0
5.00,7,30,7.50,0.564,0.0312,0.5328,0.0312,0
5.00,7,45,7.75,0.6918,4.4988,0,0.6918,3.807
5.00,8,0,8.00,0.792,0.2688,0.5232,0.2688,0
5.00,8,15,8.25,0.9498,0.1812,0.7686,0.1812,0
5.00,8,30,8.50,1.0662,0.246,0.8202,0.246,0
5.00,8,45,8.75,1.1688,0.2148,0.954,0.2148,0
5.00,9,0,9.00,1.2648,0.228,1.0368,0.228,0
5.00,9,15,9.25,1.3692,0.1422,1.227,0.1422,0
5.00,9,30,9.50,1.464,0.2232,1.2408,0.2232,0
5.00,9,45,9.75,1.5228,0.2232,1.2996,0.2232,0
5.00,10,0,10.00,1.602,0.1308,1.4712,0.1308,0
5.00,10,15,10.25,1.6428,0.1698,1.473,0.1698,0
5.00,10,30,10.50,1.7082,0.168,1.5402,0.168,0
5.00,10,45,10.75,1.7538,0.0942,1.6596,0.0942000000000001,0
5.00,11,0,11.00,1.7712,0.15,1.6212,0.15,0
5.00,11,15,11.25,1.797,0.0702,1.7268,0.0702,0
5.00,11,30,11.50,1.8438,0.5148,1.329,0.5148,0
5.00,11,45,11.75,1.8462,0.0438,1.8024,0.0438000000000001,0
5.00,12,0,12.00,1.878,0.042,1.836,0.042,0
5.00,12,15,12.25,1.866,0.0432,1.8228,0.0431999999999999,0
5.00,12,30,12.50,1.8648,0.042,1.8228,0.042,0
5.00,12,45,12.75,1.8258,0.0438,1.782,0.0438000000000001,0
5.00,13,0,13.00,1.8432,0.0432,1.8,0.0431999999999999,0
5.00,13,15,13.25,1.8018,0.0408,1.761,0.0408,0
5.00,13,30,13.50,1.7118,0.0438,1.668,0.0438000000000001,0
5.00,13,45,13.75,1.7922,0.045,1.7472,0.0449999999999999,0
5.00,14,0,14.00,1.7832,0.039,1.7442,0.0389999999999999,0
5.00,14,15,14.25,1.7088,0.1752,1.5336,0.1752,0
5.00,14,30,14.50,1.6908,0.0612,1.6296,0.0611999999999999,0
5.00,14,45,14.75,1.6092,0.1728,1.4364,0.1728,0
5.00,15,0,15.00,1.545,0.174,1.371,0.174,0
5.00,15,15,15.25,1.4772,0.0612,1.416,0.0611999999999999,0
5.00,15,30,15.50,1.404,0.144,1.26,0.144,0
5.00,15,45,15.75,1.2648,1.083,0.1818,1.083,0
5.00,16,0,16.00,1.2402,1.02,0.2202,1.02,0
5.00,16,15,16.25,1.14,0.2082,0.9318,0.2082,0
5.00,16,30,16.50,1.0458,0.1968,0.849,0.1968,0
5.00,16,45,16.75,0.936,0.1818,0.7542,0.1818,0
5.00,17,0,17.00,0.8208,0.177,0.6438,0.177,0
5.00,17,15,17.25,0.603,0.1638,0.4392,0.1638,0
5.00,17,30,17.50,0.1632,0.1818,0,0.1632,0.0186
5.00,17,45,17.75,0.147,0.1662,0,0.147,0.0192
5.00,18,0,18.00,0.147,0.1362,0.0108,0.1362,0
5.00,18,15,18.25,0.147,0.1338,0.0132,0.1338,0
5.00,18,30,18.50,0.15,0.1338,0.0162,0.1338,0
5.00,18,45,18.75,0.1452,0.132,0.0132,0.132,0
5.00,19,0,19.00,0.1788,0.123,0.0558,0.123,0
5.00,19,15,19.25,0.183,0.1308,0.0522,0.1308,0
5.00,19,30,19.50,0.1542,0.129,0.0252,0.129,0
5.00,19,45,19.75,0.1152,0.1248,0,0.1152,0.00960000000000003
5.00,20,0,20.00,0.0918,0.12,0,0.0918,0.0282
5.00,20,15,20.25,0.075,0.027,0.048,0.027,0
5.00,20,30,20.50,0.0618,0.021,0.0408,0.021,0
5.00,20,45,20.75,0.0528,0.1338,0,0.0528,0.081
5.00,21,0,21.00,0.0282,0.1272,0,0.0282,0.099
5.00,21,15,21.25,0,0.1272,0,0,0.1272
5.00,21,30,21.50,0,0.0978,0,0,0.0978
5.00,21,45,21.75,0,0.2988,0,0,0.2988
5.00,22,0,22.00,0,0.2862,0,0,0.2862
5.00,22,15,22.25,0,0.0498,0,0,0.0498
5.00,22,30,22.50,0,0.033,0,0,0.033
5.00,22,45,22.75,0,0.132,0,0,0.132
5.00,23,0,23.00,0,0.033,0,0,0.033
5.00,23,15,23.25,0,0.0318,0,0,0.0318
5.00,23,30,23.50,0,0.1338,0,0,0.1338
5.00,23,45,23.75,0,0.1302,0,0,0.1302
6.00,0,0,0.00,0,0.0318,0,0,0.0318
6.00,0,15,0.25,0,0.0312,0,0,0.0312
6.00,0,30,0.50,0,0.1278,0,0,0.1278
6.00,0,45,0.75,0,0.0312,0,0,0.0312
6.00,1,0,1.00,0,0.0318,0,0,0.0318
6.00,1,15,1.25,0,0.132,0,0,0.132
6.00,1,30,1.50,0,0.0318,0,0,0.0318
6.00,1,45,1.75,0,0.0342,0,0,0.0342
6.00,2,0,2.00,0,0.1338,0,0,0.1338
6.00,2,15,2.25,0,0.126,0,0,0.126
6.00,2,30,2.50,0,0.0318,0,0,0.0318
6.00,2,45,2.75,0,0.0312,0,0,0.0312
6.00,3,0,3.00,0,0.129,0,0,0.129
6.00,3,15,3.25,0,0.0318,0,0,0.0318
6.00,3,30,3.50,0,0.0312,0,0,0.0312
6.00,3,45,3.75,0,0.1332,0,0,0.1332
6.00,4,0,4.00,0,0.0342,0,0,0.0342
6.00,4,15,4.25,0,0.033,0,0,0.033
6.00,4,30,4.50,0,0.0312,0,0,0.0312
6.00,4,45,4.75,0,0.129,0,0,0.129
6.00,5,0,5.00,0,0.0312,0,0,0.0312
6.00,5,15,5.25,0,0.033,0,0,0.033
6.00,5,30,5.50,0,0.1338,0,0,0.1338
6.00,5,45,5.75,0.018,0.03,0,0.018,0.012
6.00,6,0,6.00,0.0258,0.036,0,0.0258,0.0102
6.00,6,15,6.25,0.0378,0.036,0.0018,0.036,0
6.00,6,30,6.50,0.0498,0.132,0,0.0498,0.0822
6.00,6,45,6.75,0.0558,0.033,0.0228,0.033,0
6.00,7,0,7.00,0.3558,0.0342,0.3216,0.0342,0
6.00,7,15,7.25,0.4788,0.141,0.3378,0.141,0
6.00,7,30,7.50,0.588,0.0342,0.5538,0.0342,0
6.00,7,45,7.75,0.72,1.356,0,0.72,0.636
6.00,8,0,8.00,0.834,0.171,0.663,0.171,0
6.00,8,15,8.25,0.9762,0.1842,0.792,0.1842,0
6.00,8,30,8.50,1.0848,0.099,0.9858,0.099,0
6.00,8,45,8.75,1.1808,0.0912,1.0896,0.0912,0
6.00,9,0,9.00,1.2738,0.1878,1.086,0.1878,0
6.00,9,15,9.25,1.3728,0.1008,1.272,0.1008,0
6.00,9,30,9.50,1.4532,0.0828,1.3704,0.0828,0
6.00,9,45,9.75,1.5192,0.1962,1.323,0.1962,0
6.00,10,0,10.00,1.572,0.0852,1.4868,0.0851999999999999,0
6.00,10,15,10.25,1.6122,0.0852,1.527,0.0851999999999999,0
6.00,10,30,10.50,1.6782,0.1908,1.4874,0.1908,0
6.00,10,45,10.75,1.701,0.0612,1.6398,0.0611999999999999,0
6.00,11,0,11.00,1.749,0.0612,1.6878,0.0611999999999999,0
6.00,11,15,11.25,1.7592,0.1692,1.59,0.1692,0
6.00,11,30,11.50,1.7868,0.0768,1.71,0.0768,0
6.00,11,45,11.75,1.7832,0.072,1.7112,0.0720000000000001,0
6.00,12,0,12.00,1.644,0.168,1.476,0.168,0
6.00,12,15,12.25,1.785,1.827,0,1.785,0.042
6.00,12,30,12.50,1.8258,0.1608,1.665,0.1608,0
6.00,12,45,12.75,1.8288,1.8972,0,1.8288,0.0684
6.00,13,0,13.00,1.7982,0.2208,1.5774,0.2208,0
6.00,13,15,13.25,1.782,1.4022,0.3798,1.4022,0
6.00,13,30,13.50,1.776,1.905,0,1.776,0.129
6.00,13,45,13.75,1.7508,0.0558,1.695,0.0558000000000001,0
6.00,14,0,14.00,1.737,0.0522,1.6848,0.0522,0
6.00,14,15,14.25,1.7352,0.159,1.5762,0.159,0
6.00,14,30,14.50,1.968,0.0402,1.9278,0.0402,0
6.00,14,45,14.75,0.6918,0.1338,0.558,0.1338,0
6.00,15,0,15.00,1.0758,0.0312,1.0446,0.0311999999999999,0
6.00,15,15,15.25,1.4778,0.4452,1.0326,0.4452,0
6.00,15,30,15.50,1.3578,0.0822,1.2756,0.0822000000000001,0
6.00,15,45,15.75,1.5228,0.06,1.4628,0.0600000000000001,0
6.00,16,0,16.00,1.0602,0.0492,1.011,0.0491999999999999,0
6.00,16,15,16.25,1.311,0.3858,0.9252,0.3858,0
6.00,16,30,16.50,1.1328,0.0588,1.074,0.0588,0
6.00,16,45,16.75,0.9432,0.033,0.9102,0.033,0
6.00,17,0,17.00,0.7812,0.138,0.6432,0.138,0
6.00,17,15,17.25,0.6072,0.0342,0.573,0.0342,0
6.00,17,30,17.50,0.3288,0.1308,0.198,0.1308,0
6.00,17,45,17.75,0.3252,0.036,0.2892,0.036,0
6.00,18,0,18.00,0.2232,0.1338,0.0894,0.1338,0
6.00,18,15,18.25,0.1722,0.0318,0.1404,0.0318,0
6.00,18,30,18.50,0.1392,0.0798,0.0594,0.0798,0
6.00,18,45,18.75,0.2052,0.0342,0.171,0.0342,0
6.00,19,0,19.00,0.1932,0.0318,0.1614,0.0318,0
6.00,19,15,19.25,0.1392,0.1308,0.00839999999999999,0.1308,0
6.00,19,30,19.50,0.084,0.0342,0.0498,0.0342,0
6.00,19,45,19.75,0.0678,0.1338,0,0.0678,0.066
6.00,20,0,20.00,0.0642,0.0288,0.0354,0.0288,0
6.00,20,15,20.25,0.0588,0.132,0,0.0588,0.0732
6.00,20,30,20.50,0.0462,0.03,0.0162,0.03,0
6.00,20,45,20.75,0.0318,0.0348,0,0.0318,0.003
6.00,21,0,21.00,0.0018,0.0288,0,0.0018,0.027
6.00,21,15,21.25,0,0.0408,0,0,0.0408
6.00,21,30,21.50,0,0.1362,0,0,0.1362
6.00,21,45,21.75,0,0.1482,0,0,0.1482
6.00,22,0,22.00,0,0.456,0,0,0.456
6.00,22,15,22.25,0,0.1848,0,0,0.1848
6.00,22,30,22.50,0,0.18,0,0,0.18
6.00,22,45,22.75,0,0.0318,0,0,0.0318
6.00,23,0,23.00,0,0.0318,0,0,0.0318
6.00,23,15,23.25,0,0.1302,0,0,0.1302
6.00,23,30,23.50,0,0.03,0,0,0.03
6.00,23,45,23.75,0,0.1818,0,0,0.1818
7.00,0,0,0.00,0,0.03,0,0,0.03
7.00,0,15,0.25,0,0.0288,0,0,0.0288
7.00,0,30,0.50,0,0.1278,0,0,0.1278
7.00,0,45,0.75,0,0.0288,0,0,0.0288
7.00,1,0,1.00,0,0.1302,0,0,0.1302
7.00,1,15,1.25,0,0.03,0,0,0.03
7.00,1,30,1.50,0,0.0282,0,0,0.0282
7.00,1,45,1.75,0,0.1272,0,0,0.1272
7.00,2,0,2.00,0,0.0288,0,0,0.0288
7.00,2,15,2.25,0,0.132,0,0,0.132
7.00,2,30,2.50,0,0.0288,0,0,0.0288
7.00,2,45,2.75,0,0.0282,0,0,0.0282
7.00,3,0,3.00,0,0.1272,0,0,0.1272
7.00,3,15,3.25,0,0.027,0,0,0.027
7.00,3,30,3.50,0,0.0282,0,0,0.0282
7.00,3,45,3.75,0,0.027,0,0,0.027
7.00,4,0,4.00,0,0.0288,0,0,0.0288
7.00,4,15,4.25,0,0.1308,0,0,0.1308
7.00,4,30,4.50,0,0.0282,0,0,0.0282
7.00,4,45,4.75,0,0.027,0,0,0.027
7.00,5,0,5.00,0,0.1272,0,0,0.1272
7.00,5,15,5.25,0,0.0288,0,0,0.0288
7.00,5,30,5.50,0,0.0288,0,0,0.0288
7.00,5,45,5.75,0,0.0282,0,0,0.0282
7.00,6,0,6.00,0.0372,0.033,0.0042,0.033,0
7.00,6,15,6.25,0.06,0.1332,0,0.06,0.0732
7.00,6,30,6.50,0.0768,0.027,0.0498,0.027,0
7.00,6,45,6.75,0.1032,0.03,0.0732,0.03,0
7.00,7,0,7.00,0.1362,0.1302,0.00600000000000001,0.1302,0
7.00,7,15,7.25,0.219,0.0288,0.1902,0.0288,0
7.00,7,30,7.50,0.36,2.2158,0,0.36,1.8558
7.00,7,45,7.75,0.519,0.5838,0,0.519,0.0648000000000001
7.00,8,0,8.00,0.4578,2.1762,0,0.4578,1.7184
7.00,8,15,8.25,1.1868,1.9032,0,1.1868,0.7164
7.00,8,30,8.50,0.4812,1.1778,0,0.4812,0.6966
7.00,8,45,8.75,1.284,0.8238,0.4602,0.8238,0
7.00,9,0,9.00,0.975,1.7868,0,0.975,0.8118
7.00,9,15,9.25,1.5222,1.314,0.2082,1.314,0
7.00,9,30,9.50,0.7392,0.8268,0,0.7392,0.0875999999999999
7.00,9,45,9.75,1.089,0.7572,0.3318,0.7572,0
7.00,10,0,10.00,1.632,0.069,1.563,0.069,0
7.00,10,15,10.25,0.54,0.153,0.387,0.153,0
7.00,10,30,10.50,1.863,0.0612,1.8018,0.0611999999999999,0
7.00,10,45,10.75,1.8942,2.2698,0,1.8942,0.3756
7.00,11,0,11.00,2.0892,0.0642,2.025,0.0642,0
7.00,11,15,11.25,2.1708,0.06,2.1108,0.0600000000000001,0
7.00,11,30,11.50,1.611,0.1398,1.4712,0.1398,0
7.00,11,45,11.75,1.143,0.0318,1.1112,0.0318000000000001,0
7.00,12,0,12.00,1.197,0.1362,1.0608,0.1362,0
7.00,12,15,12.25,1.4808,0.0372,1.4436,0.0371999999999999,0
7.00,12,30,12.50,1.4538,0.0438,1.41,0.0438000000000001,0
7.00,12,45,12.75,2.124,0.054,2.07,0.0539999999999998,0
7.00,13,0,13.00,1.8948,0.0378,1.857,0.0378000000000001,0
7.00,13,15,13.25,1.8858,0.1452,1.7406,0.1452,0
7.00,13,30,13.50,1.8258,0.0432,1.7826,0.0431999999999999,0
7.00,13,45,13.75,1.5582,0.1428,1.4154,0.1428,0
7.00,14,0,14.00,1.791,0.0408,1.7502,0.0408,0
7.00,14,15,14.25,1.716,0.0402,1.6758,0.0402,0
7.00,14,30,14.50,1.6842,0.1182,1.566,0.1182,0
7.00,14,45,14.75,1.6182,0.0348,1.5834,0.0347999999999999,0
7.00,15,0,15.00,1.5522,0.1422,1.41,0.1422,0
7.00,15,15,15.25,1.0338,0.0858,0.948,0.0858,0
7.00,15,30,15.50,1.3968,0.159,1.2378,0.159,0
7.00,15,45,15.75,1.1688,0.0672,1.1016,0.0671999999999999,0
7.00,16,0,16.00,1.4328,0.0618,1.371,0.0618000000000001,0
7.00,16,15,16.25,1.2702,2.478,0,1.2702,1.2078
7.00,16,30,16.50,0.4872,0.075,0.4122,0.075,0
7.00,16,45,16.75,0.6468,0.1182,0.5286,0.1182,0
7.00,17,0,17.00,0.9168,1.014,0,0.9168,0.0971999999999998
7.00,17,15,17.25,0.657,0.1302,0.5268,0.1302,0
7.00,17,30,17.50,0.2358,0.0402,0.1956,0.0402,0
7.00,17,45,17.75,0.2202,0.1428,0.0774,0.1428,0
7.00,18,0,18.00,0.1608,0.0408,0.12,0.0408,0
7.00,18,15,18.25,0.1518,0.1422,0.00959999999999997,0.1422,0
7.00,18,30,18.50,0.144,0.033,0.111,0.033,0
7.00,18,45,18.75,0.2022,0.1422,0.06,0.1422,0
7.00,19,0,19.00,0.168,0.0372,0.1308,0.0372,0
7.00,19,15,19.25,0.156,0.1368,0.0192,0.1368,0
7.00,19,30,19.50,0.096,0.0318,0.0642,0.0318,0
7.00,19,45,19.75,0.1158,0.1392,0,0.1158,0.0234
7.00,20,0,20.00,0.1188,0.0312,0.0876,0.0312,0
7.00,20,15,20.25,0.0978,0.0312,0.0666,0.0312,0
7.00,20,30,20.50,0.111,0.027,0.084,0.027,0
7.00,20,45,20.75,0.0822,0.0258,0.0564,0.0258,0
7.00,21,0,21.00,0.036,0.1302,0,0.036,0.0942
7.00,21,15,21.25,0,0.03,0,0,0.03
7.00,21,30,21.50,0,0.3042,0,0,0.3042
7.00,21,45,21.75,0,0.267,0,0,0.267
7.00,22,0,22.00,0,0.3492,0,0,0.3492
7.00,22,15,22.25,0,0.2418,0,0,0.2418
7.00,22,30,22.50,0,0.2682,0,0,0.2682
7.00,22,45,22.75,0,0.3462,0,0,0.3462
7.00,23,0,23.00,0,0.0312,0,0,0.0312
7.00,23,15,23.25,0,0.1308,0,0,0.1308
7.00,23,30,23.50,0,0.0318,0,0,0.0318
7.00,23,45,23.75,0,0.1362,0,0,0.1362
`,

    // Add more scenarios as needed
    FORECAST: `Day,Time,Demand (kW),Generation (kW),Surplus (kW),Surplus
1.00,00:00:00,109.44,0.00,0,0
1.00,00:15:00,99.07,12.00,0,0
1.00,00:30:00,81.93,0.00,0,0
1.00,00:45:00,84.00,0.00,0,0
1.00,01:00:00,92.17,0.00,0,0
1.00,01:15:00,89.87,0.00,0,0
1.00,01:30:00,81.96,0.00,0,0
1.00,01:45:00,82.16,0.00,0,0
1.00,02:00:00,82.14,36.00,0,0
1.00,02:15:00,91.78,180.00,88.2207,100
1.00,02:30:00,90.20,360.00,269.8007,275
1.00,02:45:00,78.00,432.00,354.0034,350
1.00,03:00:00,84.49,444.00,359.5076,350
1.00,03:15:00,79.55,528.00,448.4469,450
1.00,03:30:00,82.30,420.00,337.6957,350
1.00,03:45:00,82.38,576.00,493.618,500
1.00,04:00:00,85.92,540.00,454.0824,450
1.00,04:15:00,90.96,456.00,365.0414,375
1.00,04:30:00,96.34,492.00,395.6557,400
1.00,04:45:00,90.47,468.00,377.5274,375
1.00,05:00:00,87.48,456.00,368.5235,375
1.00,05:15:00,92.91,516.00,423.0868,425
1.00,05:30:00,112.87,456.00,343.1263,350
1.00,05:45:00,105.73,300.00,194.2668,200
1.00,06:00:00,127.74,108.00,0,0
1.00,06:15:00,137.57,108.00,0,0
1.00,06:30:00,148.42,48.00,0,0
1.00,06:45:00,130.71,24.00,0,0
1.00,07:00:00,144.52,24.00,0,0
1.00,07:15:00,123.30,72.00,0,0
1.00,07:30:00,125.89,84.00,0,0
1.00,07:45:00,147.88,36.00,0,0
1.00,08:00:00,135.60,48.00,0,0
1.00,08:15:00,124.45,396.00,271.5498,275
1.00,08:30:00,175.12,576.00,400.8782,400
1.00,08:45:00,147.01,732.00,584.9929,575
1.00,09:00:00,131.82,444.00,312.1754,300
1.00,09:15:00,149.48,612.00,462.5168,475
1.00,09:30:00,128.44,456.00,327.5623,325
1.00,09:45:00,144.84,264.00,119.1558,125
1.00,10:00:00,113.52,264.00,150.4826,150
1.00,10:15:00,127.08,240.00,112.9174,125
1.00,10:30:00,126.27,72.00,0,0
1.00,10:45:00,103.70,216.00,112.3046,100
1.00,11:00:00,110.66,204.00,93.3446,100
1.00,11:15:00,127.40,204.00,76.6015,75
1.00,11:30:00,115.92,96.00,0,0
1.00,11:45:00,105.79,180.00,74.2147,75
1.00,12:00:00,142.53,228.00,85.4669,75
1.00,12:15:00,101.82,240.00,138.1773,150,150
1.00,12:30:00,112.70,816.00,703.3002,700,700
1.00,12:45:00,139.43,336.00,196.5745,200,200
1.00,13:00:00,143.82,180.00,36.1755,25,25
1.00,13:15:00,121.75,132.00,10.2485,0,
1.00,13:30:00,104.83,156.00,51.1682,50,50
1.00,13:45:00,108.67,132.00,23.3267,25,25
1.00,14:00:00,134.50,120.00,0,0,
1.00,14:15:00,98.58,96.00,0,0,
1.00,14:30:00,114.29,276.00,161.7112,150,150
1.00,14:45:00,115.76,132.00,16.2394,25,25
1.00,15:00:00,86.58,60.00,0,0,
1.00,15:15:00,116.49,96.00,0,0,
1.00,15:30:00,141.58,48.00,0,0,
1.00,15:45:00,126.39,36.00,0,0,
1.00,16:00:00,133.32,24.00,0,0,
1.00,16:15:00,147.56,48.00,0,0,
1.00,16:30:00,141.34,108.00,0,0,
1.00,16:45:00,151.04,132.00,0,0,
1.00,17:00:00,132.87,144.00,11.1283,0,
1.00,17:15:00,138.23,144.00,5.771,0,
1.00,17:30:00,140.95,132.00,0,0,
1.00,17:45:00,161.75,72.00,0,0,
1.00,18:00:00,158.72,72.00,0,0,
1.00,18:15:00,149.41,24.00,0,0,
1.00,18:30:00,139.40,60.00,0,0,
1.00,18:45:00,138.76,48.00,0,0,
1.00,19:00:00,129.66,12.00,0,0,
1.00,19:15:00,131.63,60.00,0,0,
1.00,19:30:00,134.18,48.00,0,0,
1.00,19:45:00,140.35,36.00,0,0,
1.00,20:00:00,165.83,12.00,0,0,
1.00,20:15:00,157.39,0.00,0,0,
1.00,20:30:00,136.31,0.00,0,0,
1.00,20:45:00,126.20,0.00,0,0,
1.00,21:00:00,137.53,0.00,0,0,
1.00,21:15:00,132.01,0.00,0,0,
1.00,21:30:00,134.15,0.00,0,0,
1.00,21:45:00,115.14,0.00,0,0,
1.00,22:00:00,120.24,0.00,0,0,
1.00,22:15:00,118.19,0.00,0,0,
1.00,22:30:00,121.85,0.00,0,0,
1.00,22:45:00,101.48,0.00,0,0,
1.00,23:00:00,105.13,12.00,0,0,
1.00,23:15:00,108.39,36.00,0,0,
1.00,23:30:00,92.81,24.00,0,0,
1.00,23:45:00,86.34,0.00,0,0,
2.00,00:00:00,110.15,0.00,0,0,
2.00,00:15:00,83.41,0.00,0,0,
2.00,00:30:00,84.42,0.00,0,0,
2.00,00:45:00,81.55,0.00,0,0,
2.00,01:00:00,92.48,0.00,0,0,
2.00,01:15:00,100.60,0.00,0,0,
2.00,01:30:00,101.81,0.00,0,0,
2.00,01:45:00,91.87,0.00,0,0,
2.00,02:00:00,89.62,0.00,0,0,
2.00,02:15:00,84.37,0.00,0,0,
2.00,02:30:00,103.36,0.00,0,0,
2.00,02:45:00,102.14,0.00,0,0,
2.00,03:00:00,92.39,0.00,0,0,
2.00,03:15:00,70.30,0.00,0,0,
2.00,03:30:00,90.52,0.00,0,0,
2.00,03:45:00,85.14,0.00,0,0,
2.00,04:00:00,91.88,0.00,0,0,
2.00,04:15:00,80.38,0.00,0,0,
2.00,04:30:00,84.41,0.00,0,0,
2.00,04:45:00,91.80,36.00,0,0,
2.00,05:00:00,92.14,36.00,0,0,
2.00,05:15:00,98.78,24.00,0,0,
2.00,05:30:00,116.88,12.00,0,0,
2.00,05:45:00,131.70,0.00,0,0,
2.00,06:00:00,124.51,0.00,0,0,
2.00,06:15:00,156.65,0.00,0,0,
2.00,06:30:00,125.05,0.00,0,0,
2.00,06:45:00,109.91,0.00,0,0,
2.00,07:00:00,117.13,0.00,0,0,
2.00,07:15:00,147.77,0.00,0,0,
2.00,07:30:00,141.80,0.00,0,0,
2.00,07:45:00,131.73,0.00,0,0,
2.00,08:00:00,126.54,0.00,0,0,
2.00,08:15:00,113.54,0.00,0,0,
2.00,08:30:00,125.71,0.00,0,0,
2.00,08:45:00,112.58,0.00,0,0,
2.00,09:00:00,130.69,0.00,0,0,
2.00,09:15:00,125.15,0.00,0,0,
2.00,09:30:00,106.62,0.00,0,0,
2.00,09:45:00,113.88,0.00,0,0,
2.00,10:00:00,87.77,24.00,0,0,
2.00,10:15:00,93.35,48.00,0,0,
2.00,10:30:00,93.66,48.00,0,0,
2.00,10:45:00,101.66,24.00,0,0,
2.00,11:00:00,92.42,24.00,0,0,
2.00,11:15:00,103.97,24.00,0,0,
2.00,11:30:00,103.72,132.00,28.2774,25,25
2.00,11:45:00,104.22,216.00,111.7798,100,100
2.00,12:00:00,122.25,300.00,177.7487,175,175
2.00,12:15:00,120.62,300.00,179.3826,175,175
2.00,12:30:00,112.96,252.00,139.04,150,150
2.00,12:45:00,114.00,348.00,233.9983,225,225
2.00,13:00:00,98.75,348.00,249.2456,250,250
2.00,13:15:00,105.31,336.00,230.6889,225,225
2.00,13:30:00,103.14,360.00,256.856,250,250
2.00,13:45:00,80.98,300.00,219.0168,225,225
2.00,14:00:00,89.84,240.00,150.1606,150,150
2.00,14:15:00,73.67,288.00,214.3296,225,225
2.00,14:30:00,89.41,300.00,210.5927,200,200
2.00,14:45:00,83.02,420.00,336.9809,325,325
2.00,15:00:00,89.64,300.00,210.3626,200,200
2.00,15:15:00,93.08,312.00,218.9166,225,225
2.00,15:30:00,81.62,204.00,122.3758,125,125
2.00,15:45:00,88.57,216.00,127.4326,125,125
2.00,16:00:00,79.71,288.00,208.2895,200,200
2.00,16:15:00,102.50,156.00,53.4995,50,50
2.00,16:30:00,134.94,192.00,57.0587,50,50
2.00,16:45:00,137.12,156.00,18.8828,25,25
2.00,17:00:00,121.91,144.00,22.0893,25,25
2.00,17:15:00,127.02,156.00,28.9812,25,25
2.00,17:30:00,150.86,180.00,29.1393,25,25
2.00,17:45:00,146.92,132.00,0,0,
2.00,18:00:00,140.79,132.00,0,0,
2.00,18:15:00,123.82,252.00,128.1788,125,125
2.00,18:30:00,114.35,156.00,41.6482,50,50
2.00,18:45:00,130.04,108.00,0,0,
2.00,19:00:00,131.66,96.00,0,0,
2.00,19:15:00,156.57,36.00,0,0,
2.00,19:30:00,135.84,24.00,0,0,
2.00,19:45:00,152.89,24.00,0,0,
2.00,20:00:00,148.47,24.00,0,0,
2.00,20:15:00,142.23,24.00,0,0,
2.00,20:30:00,159.25,12.00,0,0,
2.00,20:45:00,140.69,0.00,0,0,
2.00,21:00:00,131.53,0.00,0,0,
2.00,21:15:00,122.96,0.00,0,0,
2.00,21:30:00,131.29,0.00,0,0,
2.00,21:45:00,129.09,0.00,0,0,
2.00,22:00:00,121.20,0.00,0,0,
2.00,22:15:00,102.89,0.00,0,0,
2.00,22:30:00,114.29,0.00,0,0,
2.00,22:45:00,119.23,0.00,0,0,
2.00,23:00:00,112.99,0.00,0,0,
2.00,23:15:00,93.38,0.00,0,0,
2.00,23:30:00,109.91,0.00,0,0,
2.00,23:45:00,81.02,12.00,0,0,
3.00,00:00:00,93.79,24.00,0,0,
3.00,00:15:00,87.22,48.00,0,0,
3.00,00:30:00,81.71,48.00,0,0,
3.00,00:45:00,87.90,48.00,0,0,
3.00,01:00:00,82.95,48.00,0,0,
3.00,01:15:00,89.86,24.00,0,0,
3.00,01:30:00,88.37,24.00,0,0,
3.00,01:45:00,82.48,24.00,0,0,
3.00,02:00:00,82.28,24.00,0,0,
3.00,02:15:00,81.07,60.00,0,0,
3.00,02:30:00,83.80,72.00,0,0,
3.00,02:45:00,75.46,108.00,32.5358,25,25
3.00,03:00:00,77.76,168.00,90.2424,100,100
3.00,03:15:00,68.96,192.00,123.0362,125,125
3.00,03:30:00,77.60,132.00,54.3997,50,50
3.00,03:45:00,79.29,96.00,16.7112,25,25
3.00,04:00:00,75.76,48.00,0,0,
3.00,04:15:00,92.94,72.00,0,0,
3.00,04:30:00,95.13,84.00,0,0,
3.00,04:45:00,79.50,36.00,0,0,
3.00,05:00:00,76.35,96.00,19.6514,25,25
3.00,05:15:00,91.00,72.00,0,0,
3.00,05:30:00,94.60,48.00,0,0,
3.00,05:45:00,106.48,60.00,0,0,
3.00,06:00:00,123.62,60.00,0,0,
3.00,06:15:00,124.85,72.00,0,0,
3.00,06:30:00,129.38,72.00,0,0,
3.00,06:45:00,145.02,36.00,0,0,
3.00,07:00:00,118.03,36.00,0,0,
3.00,07:15:00,136.85,12.00,0,0,
3.00,07:30:00,137.31,12.00,0,0,
3.00,07:45:00,137.13,36.00,0,0,
3.00,08:00:00,127.87,24.00,0,0,
3.00,08:15:00,136.59,48.00,0,0,
3.00,08:30:00,134.00,36.00,0,0,
3.00,08:45:00,127.72,168.00,40.2824,50,50
3.00,09:00:00,108.43,108.00,0,0,
3.00,09:15:00,113.16,72.00,0,0,
3.00,09:30:00,112.80,312.00,199.1961,200,200
3.00,09:45:00,113.38,420.00,306.6182,300,300
3.00,10:00:00,110.61,180.00,69.3916,75,75
3.00,10:15:00,105.25,108.00,2.7518,0,
3.00,10:30:00,104.83,48.00,0,0,
3.00,10:45:00,102.91,120.00,17.0928,25,25
3.00,11:00:00,117.00,264.00,147.0006,150,150
3.00,11:15:00,136.87,132.00,0,0,
3.00,11:30:00,147.77,276.00,128.2307,125,125
3.00,11:45:00,135.02,204.00,68.9767,75,75
3.00,12:00:00,180.10,180.00,0,0,
3.00,12:15:00,187.81,96.00,0,0,
3.00,12:30:00,147.51,24.00,0,0,
3.00,12:45:00,154.27,0.00,0,0,
3.00,13:00:00,132.38,0.00,0,0,
3.00,13:15:00,113.28,0.00,0,0,
3.00,13:30:00,127.74,36.00,0,0,
3.00,13:45:00,123.25,288.00,164.7541,175,175
3.00,14:00:00,133.40,144.00,10.6015,0,
3.00,14:15:00,121.18,180.00,58.8164,50,50
3.00,14:30:00,131.37,36.00,0,0,
3.00,14:45:00,125.89,144.00,18.1148,25,25
3.00,15:00:00,108.26,192.00,83.7448,75,75
3.00,15:15:00,117.20,372.00,254.8047,250,250
3.00,15:30:00,120.01,300.00,179.9906,175,175
3.00,15:45:00,107.50,132.00,24.5004,25,25
3.00,16:00:00,111.33,240.00,128.6742,125,125
3.00,16:15:00,123.21,108.00,0,0,
3.00,16:30:00,119.04,300.00,180.9574,175,175
3.00,16:45:00,114.45,252.00,137.5465,150,150
3.00,17:00:00,111.26,84.00,0,0,
3.00,17:15:00,126.41,120.00,0,0,
3.00,17:30:00,149.46,60.00,0,0,
3.00,17:45:00,159.48,144.00,0,0,
3.00,18:00:00,154.54,24.00,0,0,
3.00,18:15:00,140.18,72.00,0,0,
3.00,18:30:00,147.57,36.00,0,0,
3.00,18:45:00,158.41,72.00,0,0,
3.00,19:00:00,147.62,132.00,0,0,
3.00,19:15:00,156.00,60.00,0,0,
3.00,19:30:00,154.85,108.00,0,0,
3.00,19:45:00,151.36,48.00,0,0,
3.00,20:00:00,162.78,60.00,0,0,
3.00,20:15:00,144.30,60.00,0,0,
3.00,20:30:00,136.70,96.00,0,0,
3.00,20:45:00,134.20,108.00,0,0,
3.00,21:00:00,137.15,84.00,0,0,
3.00,21:15:00,127.78,36.00,0,0,
3.00,21:30:00,154.78,36.00,0,0,
3.00,21:45:00,121.29,12.00,0,0,
3.00,22:00:00,120.71,84.00,0,0,
3.00,22:15:00,122.29,24.00,0,0,
3.00,22:30:00,126.30,84.00,0,0,
3.00,22:45:00,119.10,72.00,0,0,
3.00,23:00:00,106.38,96.00,0,0,
3.00,23:15:00,114.30,36.00,0,0,
3.00,23:30:00,121.49,24.00,0,0,
3.00,23:45:00,97.71,0.00,0,0,
4.00,00:00:00,97.36,0.00,0,0,
4.00,00:15:00,90.88,0.00,0,0,
4.00,00:30:00,93.14,0.00,0,0,
4.00,00:45:00,102.79,0.00,0,0,
4.00,01:00:00,107.48,0.00,0,0,
4.00,01:15:00,105.14,0.00,0,0,
4.00,01:30:00,91.22,0.00,0,0,
4.00,01:45:00,98.60,0.00,0,0,
4.00,02:00:00,90.41,0.00,0,0,
4.00,02:15:00,100.07,0.00,0,0,
4.00,02:30:00,92.31,0.00,0,0,
4.00,02:45:00,92.29,12.00,0,0,
4.00,03:00:00,101.24,12.00,0,0,
4.00,03:15:00,84.45,0.00,0,0,
4.00,03:30:00,81.43,12.00,0,0,
4.00,03:45:00,102.87,60.00,0,0,
4.00,04:00:00,80.88,36.00,0,0,
4.00,04:15:00,105.58,48.00,0,0,
4.00,04:30:00,101.07,72.00,0,0,
4.00,04:45:00,93.20,24.00,0,0,
4.00,05:00:00,105.66,0.00,0,0,
4.00,05:15:00,95.01,0.00,0,0,
4.00,05:30:00,98.20,0.00,0,0,
4.00,05:45:00,99.90,0.00,0,0,
4.00,06:00:00,104.20,0.00,0,0,
4.00,06:15:00,119.69,0.00,0,0,
4.00,06:30:00,136.07,0.00,0,0,
4.00,06:45:00,110.67,0.00,0,0,
4.00,07:00:00,137.29,0.00,0,0,
4.00,07:15:00,141.04,0.00,0,0,
4.00,07:30:00,151.26,0.00,0,0,
4.00,07:45:00,134.18,0.00,0,0,
4.00,08:00:00,153.33,0.00,0,0,
4.00,08:15:00,136.50,0.00,0,0,
4.00,08:30:00,160.97,0.00,0,0,
4.00,08:45:00,123.77,0.00,0,0,
4.00,09:00:00,157.56,60.00,0,0,
4.00,09:15:00,147.39,156.00,8.6071,0,
4.00,09:30:00,172.77,132.00,0,0,
4.00,09:45:00,183.78,48.00,0,0,
4.00,10:00:00,183.26,36.00,0,0,
4.00,10:15:00,207.19,24.00,0,0,
4.00,10:30:00,199.96,24.00,0,0,
4.00,10:45:00,188.41,96.00,0,0,
4.00,11:00:00,167.82,120.00,0,0,
4.00,11:15:00,162.87,72.00,0,0,
4.00,11:30:00,165.49,144.00,0,0,
4.00,11:45:00,174.06,252.00,77.9361,75,75
4.00,12:00:00,172.79,72.00,0,0,
4.00,12:15:00,156.25,60.00,0,0,
4.00,12:30:00,147.20,48.00,0,0,
4.00,12:45:00,156.52,12.00,0,0,
4.00,13:00:00,169.00,216.00,46.9986,50,50
4.00,13:15:00,162.61,168.00,5.3876,0,
4.00,13:30:00,155.27,228.00,72.7269,75,75
4.00,13:45:00,154.15,192.00,37.854,50,50
4.00,14:00:00,136.63,120.00,0,0,
4.00,14:15:00,144.99,276.00,131.0101,125,125
4.00,14:30:00,155.53,240.00,84.469,75,75
4.00,14:45:00,139.42,264.00,124.5826,125,125
4.00,15:00:00,147.74,216.00,68.2569,75,75
4.00,15:15:00,130.93,240.00,109.067,100,100
4.00,15:30:00,140.81,204.00,63.1926,75,75
4.00,15:45:00,140.93,252.00,111.0739,100,100
4.00,16:00:00,163.85,240.00,76.149,75,75
4.00,16:15:00,134.63,288.00,153.3733,150,150
4.00,16:30:00,116.61,180.00,63.3864,75,75
4.00,16:45:00,123.16,204.00,80.836,75,75
4.00,17:00:00,160.48,204.00,43.5236,50,50
4.00,17:15:00,157.65,312.00,154.355,150,150
4.00,17:30:00,181.52,264.00,82.4788,75,75
4.00,17:45:00,196.69,276.00,79.308,75,75
4.00,18:00:00,162.11,132.00,0,0,
4.00,18:15:00,139.07,192.00,52.9324,50,50
4.00,18:30:00,130.76,72.00,0,0,
4.00,18:45:00,128.74,192.00,63.2567,75,75
4.00,19:00:00,149.47,60.00,0,0,
4.00,19:15:00,161.42,60.00,0,0,
4.00,19:30:00,177.82,36.00,0,0,
4.00,19:45:00,163.45,60.00,0,0,
4.00,20:00:00,167.29,24.00,0,0,
4.00,20:15:00,143.58,24.00,0,0,
4.00,20:30:00,145.79,72.00,0,0,
4.00,20:45:00,136.68,48.00,0,0,
4.00,21:00:00,135.96,12.00,0,0,
4.00,21:15:00,134.90,36.00,0,0,
4.00,21:30:00,144.21,36.00,0,0,
4.00,21:45:00,136.32,0.00,0,0,
4.00,22:00:00,138.99,0.00,0,0,
4.00,22:15:00,145.43,12.00,0,0,
4.00,22:30:00,168.90,12.00,0,0,
4.00,22:45:00,134.05,12.00,0,0,
4.00,23:00:00,121.27,0.00,0,0,
4.00,23:15:00,116.22,0.00,0,0,
4.00,23:30:00,116.49,12.00,0,0,
4.00,23:45:00,119.41,24.00,0,0,
5.00,00:00:00,98.97,48.00,0,0,
5.00,00:15:00,110.96,48.00,0,0,
5.00,00:30:00,98.19,120.00,21.8097,25,25
5.00,00:45:00,95.22,120.00,24.7802,25,25
5.00,01:00:00,104.01,48.00,0,0,
5.00,01:15:00,120.55,24.00,0,0,
5.00,01:30:00,96.28,24.00,0,0,
5.00,01:45:00,91.08,36.00,0,0,
5.00,02:00:00,105.02,12.00,0,0,
5.00,02:15:00,115.73,0.00,0,0,
5.00,02:30:00,97.22,0.00,0,0,
5.00,02:45:00,97.18,60.00,0,0,
5.00,03:00:00,83.20,48.00,0,0,
5.00,03:15:00,93.96,12.00,0,0,
5.00,03:30:00,88.27,12.00,0,0,
5.00,03:45:00,98.75,24.00,0,0,
5.00,04:00:00,84.73,0.00,0,0,
5.00,04:15:00,94.15,0.00,0,0,
5.00,04:30:00,79.16,0.00,0,0,
5.00,04:45:00,97.76,24.00,0,0,
5.00,05:00:00,99.54,60.00,0,0,
5.00,05:15:00,98.21,0.00,0,0,
5.00,05:30:00,88.02,0.00,0,0,
5.00,05:45:00,110.08,0.00,0,0,
5.00,06:00:00,102.65,24.00,0,0,
5.00,06:15:00,132.17,24.00,0,0,
5.00,06:30:00,112.15,24.00,0,0,
5.00,06:45:00,108.57,0.00,0,0,
5.00,07:00:00,126.76,12.00,0,0,
5.00,07:15:00,118.32,0.00,0,0,
5.00,07:30:00,129.30,0.00,0,0,
5.00,07:45:00,119.49,0.00,0,0,
5.00,08:00:00,163.06,0.00,0,0,
5.00,08:15:00,138.26,0.00,0,0,
5.00,08:30:00,152.31,0.00,0,0,
5.00,08:45:00,138.73,72.00,0,0,
5.00,09:00:00,121.34,204.00,82.6588,75,75
5.00,09:15:00,136.40,288.00,151.6048,150,150
5.00,09:30:00,152.50,132.00,0,0,
5.00,09:45:00,133.54,204.00,70.462,75,75
5.00,10:00:00,130.85,264.00,133.1461,125,125
5.00,10:15:00,119.23,360.00,240.7693,250,250
5.00,10:30:00,127.39,312.00,184.6076,175,175
5.00,10:45:00,152.21,216.00,63.7921,75,75
5.00,11:00:00,111.45,156.00,44.5518,50,50
5.00,11:15:00,130.52,228.00,97.4761,100,100
5.00,11:30:00,102.78,108.00,5.225,0,
5.00,11:45:00,122.08,168.00,45.9188,50,50
5.00,12:00:00,92.99,264.00,171.0053,175,175
5.00,12:15:00,111.21,192.00,80.7918,75,75
5.00,12:30:00,126.21,120.00,0,0,
5.00,12:45:00,158.55,120.00,0,0,
5.00,13:00:00,112.12,36.00,0,0,
5.00,13:15:00,103.61,48.00,0,0,
5.00,13:30:00,107.96,168.00,60.0445,50,50
5.00,13:45:00,115.49,204.00,88.5085,100,100
5.00,14:00:00,113.46,144.00,30.5396,25,25
5.00,14:15:00,99.52,96.00,0,0,
5.00,14:30:00,89.80,60.00,0,0,
5.00,14:45:00,97.00,36.00,0,0,
5.00,15:00:00,110.85,72.00,0,0,
5.00,15:15:00,102.90,72.00,0,0,
5.00,15:30:00,122.18,60.00,0,0,
5.00,15:45:00,111.78,384.00,272.2169,275,275
5.00,16:00:00,123.80,324.00,200.198,200,200
5.00,16:15:00,138.23,168.00,29.7732,25,25
5.00,16:30:00,128.25,60.00,0,0,
5.00,16:45:00,120.08,36.00,0,0,
5.00,17:00:00,125.26,180.00,54.7356,50,50
5.00,17:15:00,131.14,192.00,60.8619,50,50
5.00,17:30:00,132.98,60.00,0,0,
5.00,17:45:00,115.81,144.00,28.1942,25,25
5.00,18:00:00,138.77,252.00,113.2279,125,125
5.00,18:15:00,148.81,180.00,31.195,25,25
5.00,18:30:00,148.40,192.00,43.6042,50,50
5.00,18:45:00,144.33,96.00,0,0,
5.00,19:00:00,152.77,132.00,0,0,
5.00,19:15:00,156.03,24.00,0,0,
5.00,19:30:00,140.83,48.00,0,0,
5.00,19:45:00,139.87,108.00,0,0,
5.00,20:00:00,137.95,96.00,0,0,
5.00,20:15:00,123.35,132.00,8.654,0,
5.00,20:30:00,146.42,156.00,9.5846,0,
5.00,20:45:00,126.21,120.00,0,0,
5.00,21:00:00,136.46,12.00,0,0,
5.00,21:15:00,120.05,0.00,0,0,
5.00,21:30:00,140.80,24.00,0,0,
5.00,21:45:00,102.06,36.00,0,0,
5.00,22:00:00,108.74,36.00,0,0,
5.00,22:15:00,112.75,48.00,0,0,
5.00,22:30:00,118.73,0.00,0,0,
5.00,22:45:00,104.21,60.00,0,0,
5.00,23:00:00,119.95,12.00,0,0,
5.00,23:15:00,108.42,48.00,0,0,
5.00,23:30:00,108.70,60.00,0,0,
5.00,23:45:00,105.73,84.00,0,0,
6.00,00:00:00,102.98,96.00,0,0,
6.00,00:15:00,103.47,12.00,0,0,
6.00,00:30:00,96.86,60.00,0,0,
6.00,00:45:00,99.73,24.00,0,0,
6.00,02:00:00,93.54,0.00,0,0,
6.00,02:15:00,100.94,96.00,0,0,
6.00,02:30:00,103.65,48.00,0,0,
6.00,02:45:00,99.39,24.00,0,0,
6.00,03:00:00,103.41,12.00,0,0,
6.00,03:15:00,94.87,24.00,0,0,
6.00,03:30:00,87.52,12.00,0,0,
6.00,03:45:00,97.55,24.00,0,0,
6.00,04:00:00,91.87,12.00,0,0,
6.00,04:15:00,90.98,12.00,0,0,
6.00,04:30:00,92.08,84.00,0,0,
6.00,04:45:00,84.69,48.00,0,0,
6.00,05:00:00,86.67,120.00,33.3286,25,25
6.00,05:15:00,90.68,132.00,41.3249,50,50
6.00,05:30:00,101.34,144.00,42.6605,50,50
6.00,05:45:00,85.02,96.00,10.9817,0,
6.00,06:00:00,100.27,12.00,0,0,
6.00,06:15:00,113.40,60.00,0,0,
6.00,06:30:00,109.07,48.00,0,0,
6.00,06:45:00,127.38,36.00,0,0,
6.00,07:00:00,110.31,36.00,0,0,
6.00,07:15:00,103.72,120.00,16.2795,25,25
6.00,07:30:00,117.25,12.00,0,0,
6.00,07:45:00,102.35,24.00,0,0,
6.00,08:00:00,121.05,72.00,0,0,
6.00,08:15:00,107.35,36.00,0,0,
6.00,08:30:00,140.40,12.00,0,0,
6.00,08:45:00,120.67,0.00,0,0,
6.00,09:00:00,123.99,48.00,0,0,
6.00,09:15:00,141.28,180.00,38.7205,50,50
6.00,09:30:00,126.90,60.00,0,0,
6.00,09:45:00,139.06,24.00,0,0,
6.00,10:00:00,165.59,48.00,0,0,
6.00,10:15:00,103.29,84.00,0,0,
6.00,10:30:00,115.02,144.00,28.9751,25,25
6.00,10:45:00,116.57,24.00,0,0,
6.00,11:00:00,119.28,36.00,0,0,
6.00,11:15:00,107.98,48.00,0,0,
6.00,11:30:00,105.60,72.00,0,0,
6.00,11:45:00,108.01,84.00,0,0,
6.00,12:00:00,117.79,72.00,0,0,
6.00,12:15:00,114.05,72.00,0,0,
6.00,12:30:00,123.81,36.00,0,0,
6.00,12:45:00,116.20,36.00,0,0,
6.00,13:00:00,101.87,24.00,0,0,
6.00,13:15:00,111.77,36.00,0,0,
6.00,13:30:00,108.54,48.00,0,0,
6.00,13:45:00,104.08,72.00,0,0,
6.00,14:00:00,135.83,72.00,0,0,
6.00,14:15:00,99.58,180.00,80.4156,75,75
6.00,14:30:00,121.02,84.00,0,0,
6.00,14:45:00,105.99,276.00,170.0112,175,175
6.00,15:00:00,80.99,192.00,111.0089,100,100
6.00,15:15:00,88.11,324.00,235.8906,225,225
6.00,15:30:00,90.05,420.00,329.9466,325,325
6.00,15:45:00,113.53,324.00,210.4701,200,200
6.00,16:00:00,102.29,312.00,209.7087,200,200
6.00,16:15:00,108.50,300.00,191.4952,200,200
6.00,16:30:00,102.89,264.00,161.1124,150,150
6.00,16:45:00,113.68,132.00,18.3207,25,25
6.00,17:00:00,133.10,48.00,0,0,
6.00,17:15:00,121.40,72.00,0,0,
6.00,17:30:00,119.79,72.00,0,0,
6.00,17:45:00,128.91,60.00,0,0,
6.00,18:00:00,132.61,72.00,0,0,
6.00,18:15:00,119.29,96.00,0,0,
6.00,18:30:00,153.09,48.00,0,0,
6.00,18:45:00,169.46,48.00,0,0,
6.00,19:00:00,137.25,84.00,0,0,
6.00,19:15:00,167.49,96.00,0,0,
6.00,19:30:00,159.53,48.00,0,0,
6.00,19:45:00,152.18,156.00,3.818,0,
6.00,20:00:00,148.45,120.00,0,0,
6.00,20:15:00,150.19,72.00,0,0,
6.00,20:30:00,161.14,60.00,0,0,
6.00,20:45:00,149.14,120.00,0,0,
6.00,21:00:00,140.83,132.00,0,0,
6.00,21:15:00,133.26,108.00,0,0,
6.00,21:30:00,127.96,84.00,0,0,
6.00,21:45:00,124.26,72.00,0,0,
6.00,22:00:00,127.90,204.00,76.0964,75,75
6.00,22:15:00,137.87,24.00,0,0,
6.00,22:30:00,127.27,0.00,0,0,
6.00,22:45:00,121.35,96.00,0,0,
6.00,23:00:00,112.91,96.00,0,0,
6.00,23:15:00,105.97,48.00,0,0,
6.00,23:30:00,115.60,0.00,0,0,
6.00,23:45:00,99.35,0.00,0,0,
7.00,00:00:00,125.04,48.00,0,0,
7.00,00:15:00,98.94,0.00,0,0,
7.00,00:30:00,84.89,0.00,0,0,
7.00,00:45:00,77.12,96.00,18.8819,25,25
7.00,01:00:00,79.46,36.00,0,0,
7.00,01:15:00,87.56,84.00,0,0,
7.00,01:30:00,84.07,48.00,0,0,
7.00,01:45:00,85.33,60.00,0,0,
7.00,02:00:00,89.92,36.00,0,0,
7.00,02:15:00,95.66,36.00,0,0,
7.00,02:30:00,92.11,48.00,0,0,
7.00,02:45:00,87.37,84.00,0,0,
7.00,03:00:00,96.21,84.00,0,0,
7.00,03:15:00,107.78,48.00,0,0,
7.00,03:30:00,91.17,60.00,0,0,
7.00,03:45:00,81.45,36.00,0,0,
7.00,04:00:00,91.69,48.00,0,0,
7.00,04:15:00,93.56,84.00,0,0,
7.00,04:30:00,87.42,72.00,0,0,
7.00,04:45:00,106.36,60.00,0,0,
7.00,05:00:00,97.33,48.00,0,0,
7.00,05:15:00,93.72,36.00,0,0,
7.00,05:30:00,104.48,0.00,0,0,
7.00,05:45:00,85.33,0.00,0,0,
7.00,06:00:00,103.98,0.00,0,0,
7.00,06:15:00,120.93,12.00,0,0,
7.00,06:30:00,105.75,0.00,0,0,
7.00,06:45:00,152.93,0.00,0,0,
7.00,07:00:00,134.48,0.00,0,0,
7.00,07:15:00,133.94,0.00,0,0,
7.00,07:30:00,123.28,0.00,0,0,
7.00,07:45:00,111.83,0.00,0,0,
7.00,08:00:00,150.86,12.00,0,0,
7.00,08:15:00,143.14,0.00,0,0,
7.00,08:30:00,153.21,0.00,0,0,
7.00,08:45:00,173.37,0.00,0,0,
7.00,09:00:00,166.45,0.00,0,0,
7.00,09:15:00,169.11,0.00,0,0,
7.00,09:30:00,168.40,0.00,0,0,
7.00,09:45:00,156.56,0.00,0,0,
7.00,10:00:00,175.87,0.00,0,0,
7.00,10:15:00,163.31,0.00,0,0,
7.00,10:30:00,154.80,0.00,0,0,
7.00,10:45:00,152.19,0.00,0,0,
7.00,11:00:00,136.31,0.00,0,0,
7.00,11:15:00,137.46,12.00,0,0,
7.00,11:30:00,127.90,24.00,0,0,
7.00,11:45:00,147.34,84.00,0,0,
7.00,12:00:00,122.90,84.00,0,0,
7.00,12:15:00,135.27,96.00,0,0,
7.00,12:30:00,100.72,60.00,0,0,
7.00,12:45:00,110.92,180.00,69.0843,75,75
7.00,13:00:00,105.57,156.00,50.4296,50,50
7.00,13:15:00,109.39,96.00,0,0,
7.00,13:30:00,100.42,180.00,79.5767,75,75
7.00,13:45:00,97.80,132.00,34.2006,25,25
7.00,14:00:00,87.06,300.00,212.9405,225,225
7.00,14:15:00,80.76,204.00,123.2439,125,125
7.00,14:30:00,84.96,120.00,35.04,25,25
7.00,14:45:00,102.31,180.00,77.6931,75,75
7.00,15:00:00,106.97,288.00,181.0343,175,175
7.00,15:15:00,89.99,252.00,162.0077,150,150
7.00,15:30:00,116.03,348.00,231.9659,225,225
7.00,15:45:00,92.19,408.00,315.8114,325,325
7.00,16:00:00,104.73,264.00,159.2702,150,150
7.00,16:15:00,107.60,192.00,84.4001,75,75
7.00,16:30:00,92.02,156.00,63.9758,75,75
7.00,16:45:00,88.41,144.00,55.5853,50,50
7.00,17:00:00,134.87,168.00,33.1318,25,25
7.00,17:15:00,140.16,168.00,27.8408,25,25
7.00,17:30:00,134.89,204.00,69.1054,75,75
7.00,17:45:00,162.50,180.00,17.5016,25,25
7.00,18:00:00,143.84,144.00,0.1561,0,
7.00,18:15:00,87.03,228.00,140.9695,150,150
7.00,18:30:00,101.72,144.00,42.2826,50,50
7.00,18:45:00,92.17,324.00,231.8334,225,225
7.00,19:00:00,121.43,300.00,178.5742,175,175
7.00,19:15:00,131.92,180.00,48.0846,50,50
7.00,19:30:00,140.93,144.00,3.0732,0,
7.00,19:45:00,122.48,216.00,93.5223,100,100
7.00,20:00:00,137.83,168.00,30.1686,25,25
7.00,20:15:00,132.06,72.00,0,0,
7.00,20:30:00,128.11,0.00,0,0,
7.00,20:45:00,133.52,24.00,0,0,
7.00,21:00:00,142.21,36.00,0,0,
7.00,21:15:00,150.85,48.00,0,0,
7.00,21:30:00,134.20,72.00,0,0,
7.00,21:45:00,130.62,60.00,0,0,
7.00,22:00:00,144.29,12.00,0,0,
7.00,22:15:00,132.02,48.00,0,0,
7.00,22:30:00,134.78,60.00,0,0,
7.00,22:45:00,114.50,96.00,0,0,
7.00,23:00:00,119.80,132.00,12.1968,0,
7.00,23:15:00,108.38,48.00,0,0,
7.00,23:30:00,116.09,48.00,0,0,
7.00,23:45:00,112.96,0.00,0,0,
`};

// CSV file configurations
export const CSV_CONFIGS = {
    DATA: {
        filename: 'findhorn_data.csv',
        dayColumn: 'Day',
        timeColumn: 'Time',
        hourColumn: 'Hour',
        minsColumn: 'Mins',
        demandColumn: 'demand_kW',
        generationColumn: 'generation_kW',
        surplusColumn: 'Surplus (kW)'
    },
    // Add more CSV configurations here
    FORECAST: {
        filename: 'findhorn_forecast.csv',
        dayColumn: 'Day',
        timeColumn: 'Time', // This is "HH:MM:SS" format
        demandColumn: 'Demand (kW)',
        generationColumn: 'Generation (kW)',
        surplusColumn: 'Surplus (kW)'
    }
    // Add more as needed...
};

// Generic CSV parser with improved error handling
export const parseCsvData = (csvString) => {
    console.log("📊 Starting CSV parsing...");
    console.log("Raw CSV preview:", csvString.substring(0, 200));

    if (!csvString || typeof csvString !== 'string') {
        throw new Error("Invalid CSV data: expected string, got " + typeof csvString);
    }

    const lines = csvString.trim().split('\n');
    console.log("Total lines found:", lines.length);

    if (lines.length < 2) {
        throw new Error("CSV data appears to be empty or has no data rows");
    }

    const headers = lines[0].split(',').map(header =>
        header.trim().replace(/"/g, '').replace(/^\uFEFF/, '')
    );
    console.log("Headers found:", headers);

    const parsedData = [];

    for (let i = 1; i < lines.length; i++) {
        try {
            const values = lines[i].split(',').map(val => val.trim().replace(/"/g, ''));

            if (values.length < headers.length || values.every(val => val === '')) {
                console.warn(`Skipping empty row ${i}`);
                continue;
            }

            const row = {};

            headers.forEach((header, index) => {
                const value = values[index] || '';

                // Convert numeric columns
                if (header.toLowerCase().includes('day') ||
                    header.toLowerCase().includes('hour') ||
                    header.toLowerCase().includes('mins') ||
                    header.toLowerCase().includes('generation') ||
                    header.toLowerCase().includes('demand') ||
                    header.toLowerCase().includes('surplus') ||
                    header.toLowerCase().includes('pv') ||
                    header.toLowerCase().includes('residual')) {
                    const numValue = parseFloat(value);
                    row[header] = isNaN(numValue) ? 0 : numValue;
                } else if (header.toLowerCase().includes('time') && !header.toLowerCase().includes('day')) {
                    // Handle time columns - keep as string for HH:MM:SS format
                    row[header] = value;
                } else {
                    row[header] = value;
                }
            });

            // Only include rows that have a valid day value
            const dayHeader = headers.find(h => h.toLowerCase().includes('day')) || 'Day';
            const dayValue = row[dayHeader];
            if (dayValue !== undefined && dayValue !== null && !isNaN(dayValue)) {
                parsedData.push(row);
            }
        } catch (rowError) {
            console.warn(`Error parsing row ${i}:`, rowError);
        }
    }

    console.log("✅ Parsed data rows:", parsedData.length);
    console.log("Sample parsed row:", parsedData[0]);

    return {
        data: parsedData,
        headers: headers,
        totalRows: parsedData.length
    };
};

// Main function to get parsed CSV data with type validation
export const getParsedCsvData = async (csvType = 'FORECAST') => {
    try {
        console.log(`📊 Loading ${csvType} data from raw CSV string...`);

        // Validate csvType parameter
        if (typeof csvType !== 'string') {
            throw new Error(`Invalid CSV type parameter: expected string, got ${typeof csvType}`);
        }

        const csvString = CSV_RAW_DATA[csvType];
        if (!csvString) {
            throw new Error(`No raw data available for CSV type: ${csvType}. Available types: ${Object.keys(CSV_RAW_DATA).join(', ')}`);
        }

        const result = parseCsvData(csvString);
        console.log(`✅ Successfully loaded ${result.totalRows} rows for ${csvType}`);

        return result;
    } catch (error) {
        console.error(`❌ Error loading ${csvType} data:`, error);
        throw error; // Re-throw to allow proper error handling upstream
    }
};

// Helper function to convert "HH:MM:SS" to decimal hours
const parseTimeToDecimal = (timeString) => {
    if (!timeString || typeof timeString !== 'string') {
        return 0;
    }

    const parts = timeString.split(':');
    const hours = parseInt(parts[0]) || 0;
    const minutes = parseInt(parts[1]) || 0;
    const seconds = parseInt(parts[2]) || 0;

    return hours + minutes / 60 + seconds / 3600;
};

export const getDataForDay = async (day, csvType = 'FORECAST', allData = null) => {
    try {
        console.log(`🔍 Getting data for day ${day} from ${csvType}`);

        // Validate parameters
        if (typeof csvType !== 'string') {
            throw new Error(`Invalid csvType parameter: expected string, got ${typeof csvType}`);
        }

        const config = CSV_CONFIGS[csvType];
        if (!config) {
            throw new Error(`No configuration found for CSV type: ${csvType}`);
        }

        const csvData = allData || (await getParsedCsvData(csvType)).data;

        if (!Array.isArray(csvData)) {
            throw new Error(`Invalid CSV data: expected array, got ${typeof csvData}`);
        }

        const dayData = csvData.filter(row => row[config.dayColumn] === day);
        console.log(`📈 Found ${dayData.length} data points for day ${day} in ${csvType}`);

        // Handle different CSV formats
        if (csvType === 'FORECAST') {
            // FORECAST CSV format: has Time as "HH:MM:SS" and different column structure
            return dayData.map((row, index) => {
                const timeStr = row.Time || `${Math.floor(index / 4).toString().padStart(2, '0')}:${((index % 4) * 15).toString().padStart(2, '0')}:00`;
                const timeDecimal = parseTimeToDecimal(timeStr);

                return {
                    time: timeStr.substring(0, 5), // Extract HH:MM from HH:MM:SS
                    timeDecimal: timeDecimal,
                    generation: row['Generation (kW)'] || 0,
                    demand: row['Demand (kW)'] || 0,
                    production: row['Generation (kW)'] || 0,
                    consumption: row['Demand (kW)'] || 0,
                    surplus: row['Surplus (kW)'] || 0,
                    surplusInt: row.Surplus || 0 // This is the integer value used for color coding
                };
            }).sort((a, b) => a.timeDecimal - b.timeDecimal);
        } else {
            // DATA CSV format: has Hour, Mins columns and different structure  
            return dayData.map(row => ({
                time: `${row[config.hourColumn].toString().padStart(2, '0')}:${row[config.minsColumn].toString().padStart(2, '0')}`,
                timeDecimal: row[config.timeColumn],
                generation: row[config.generationColumn] || 0,
                demand: row[config.demandColumn] || 0,
                production: row[config.generationColumn] || 0,
                consumption: row[config.demandColumn] || 0,
                surplus: row[config.surplusColumn] || 0,
                pvUsed: row['PV used'] || 0,
                residualDemand: row['Residual demand (kW)'] || 0
            })).sort((a, b) => a.timeDecimal - b.timeDecimal);
        }
    } catch (error) {
        console.error(`❌ Error getting data for day ${day}:`, error);
        throw error;
    }
};

export const getAvailableDays = async (csvType = 'FORECAST', allData = null) => {
    try {
        console.log(`🔍 Getting available days for ${csvType}`);

        // Validate parameters
        if (typeof csvType !== 'string') {
            throw new Error(`Invalid csvType parameter: expected string, got ${typeof csvType}`);
        }

        const config = CSV_CONFIGS[csvType];
        if (!config) {
            throw new Error(`No configuration found for CSV type: ${csvType}`);
        }

        const csvData = allData || (await getParsedCsvData(csvType)).data;

        if (!Array.isArray(csvData)) {
            throw new Error(`Invalid CSV data: expected array, got ${typeof csvData}`);
        }

        const days = [...new Set(csvData.map(row => row[config.dayColumn]))].sort((a, b) => a - b);
        console.log(`📅 Found ${days.length} available days:`, days);

        return days;
    } catch (error) {
        console.error(`❌ Error getting available days:`, error);
        throw error;
    }
};

// Utility functions
export const getAvailableCsvTypes = () => {
    return Object.keys(CSV_CONFIGS);
};

export const getCsvTypeInfo = (csvType) => {
    return CSV_CONFIGS[csvType];
};